import { createQueryClient } from '@/lib/query-client';

/**
 * Single `QueryClient` for the browser Inertia app. Created once per browser
 * session (module scope) so cached reference data (CNAE, NBS, service list,
 * ...) survives Inertia page visits.
 *
 * Lives in its own module, imported only by the browser entry (`app.tsx`) and
 * the logout handlers that clear it — `lib/query-client.ts` is also imported
 * by the SSR bundle (`ssr.tsx`), and a singleton built there would be
 * constructed (and discarded) on every server render.
 */
export const queryClient = createQueryClient();
